import { useAuth } from '../hooks/use-auth';

export function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Dashboard</h1>

      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Welcome, {user?.firstName}!</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-gray-700 rounded p-4">
            <p className="text-gray-400 text-sm">Email</p>
            <p className="font-medium">{user?.email}</p>
          </div>
          <div className="bg-gray-700 rounded p-4">
            <p className="text-gray-400 text-sm">Role</p>
            <p className="font-medium capitalize">{user?.role}</p>
          </div>
        </div>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Getting Started</h2>
        <ul className="space-y-2 text-gray-300">
          <li>1. Customize this template for your needs</li>
          <li>2. Add new features and components</li>
          <li>3. Deploy to Azure using the GitHub Actions</li>
        </ul>
      </div>
    </div>
  );
}
